import { LatencySource } from '../../services/networkLatencyObserver';

export const NETWORK_STATUS = {
  GOOD: 'good',
  DEGRADED: 'degraded',
  OFFLINE: 'offline',
} as const;

export type NetworkStatus = (typeof NETWORK_STATUS)[keyof typeof NETWORK_STATUS];

export interface NetworkInformation extends EventTarget {
  effectiveType?: string;
  rtt?: number;
  downlink?: number;
  saveData?: boolean;
}

export interface NetworkSignals {
  isOnline: boolean;
  effectiveType?: string;
  rtt?: number;
  downlink?: number;
  measuredDownlinkMbps?: number;
  rollingAverageLatencyMs?: number;
  hasNetworkMeasurement?: boolean;
  latencySource?: LatencySource;
  timeoutCountInWindow: number;
  sampleCount: number;
}

export interface NetworkQualityContext {
  effectiveType?: string;
  rtt?: number;
  downlink?: number;
  measuredDownlinkMbps?: number;
  rollingAverageLatencyMs?: number;
  hasNetworkMeasurement?: boolean;
  latencySource?: LatencySource;
}
